// Português (Brasil): idioma padrão e fonte das chaves de tradução.
const pt = {
  // comum
  "common.loading": "Carregando…",
  "common.close": "Fechar",
  "common.back": "Voltar",
  "common.theme": "Trocar tema",
  "common.language": "Idioma",
  "common.error": "Algo deu errado. Tente de novo.",

  // contas
  "auth.login": "Entrar",
  "auth.loginField": "Usuário ou e-mail",
  "auth.password": "Senha",
  "auth.forgotLink": "Esqueci minha senha",
  "auth.newHere": "Novo por aqui?",
  "auth.createAccount": "Criar conta",
  "auth.haveAccount": "Já tem conta?",
  "auth.username": "Usuário",
  "auth.usernameHint": "3 a 20 caracteres: letras minúsculas, números e _. Usado para entrar.",
  "auth.email": "E-mail",
  "auth.emailHint": "Enviaremos um link de confirmação. Ele serve para recuperar a senha.",
  "auth.nickname": "Apelido",
  "auth.nicknameHint": "Como você aparece nas partidas (3 a 16 caracteres).",
  "auth.passwordHint": "Pelo menos 8 caracteres.",
  "auth.confirm": "Confirmar senha",
  "auth.err.login": "Informe o usuário ou e-mail.",
  "auth.err.password": "Informe a senha.",
  "auth.err.username": "3 a 20 caracteres: letras minúsculas, números e _.",
  "auth.err.email": "E-mail inválido.",
  "auth.err.nickname": "O apelido precisa de 3 a 16 caracteres.",
  "auth.err.passwordShort": "Use pelo menos 8 caracteres.",
  "auth.err.confirm": "As senhas não conferem.",
  "auth.forgot": "Recuperar senha",
  "auth.forgotText": "Informe seu e-mail. Se houver uma conta, enviaremos um link que vale por 30 minutos.",
  "auth.sendLink": "Enviar link",
  "auth.backToLogin": "Voltar para entrar",
  "auth.forgotSent": "Se o e-mail estiver cadastrado, o link chega em instantes. Confira também o spam.",
  "auth.newPassword": "Nova senha",
  "auth.newPasswordTitle": "Criar nova senha",
  "auth.savePassword": "Salvar senha",
  "auth.passwordChanged": "Senha alterada! Entre com a nova senha.",
  "auth.linkIncomplete": "Link incompleto. Peça um novo em Recuperar senha.",
  "auth.verifyTitle": "Confirmar e-mail",
  "auth.verifying": "Confirmando…",
  "auth.goMenu": "Ir para o menu",
  "auth.verified": "E-mail confirmado!",
  "auth.verifyFailed": "Link inválido ou expirado. No menu, peça um novo link de confirmação.",
  // erros da API
  "err.offline": "Sem conexão com o servidor. Verifique sua internet.",
  "err.invalidCredentials": "Usuário, e-mail ou senha incorretos.",
  "err.tooManyAttempts": "Muitas tentativas. Espere alguns minutos e tente de novo.",
  "err.rateLimited": "Muitas requisições seguidas. Aguarde um pouco.",
  "err.usernameTaken": "Esse usuário já está em uso.",
  "err.emailTaken": "Já existe uma conta com esse e-mail.",
  "err.invalidToken": "Link inválido ou expirado. Peça um novo.",
  "err.banned": "Esta conta está suspensa.",
  "err.nicknameCooldown": "Você só pode trocar o apelido a cada {days} dias.",
  "err.alreadyVerified": "Seu e-mail já está confirmado.",
  "err.unauthenticated": "Sua sessão expirou. Entre de novo.",
  "err.validation": "Confira os campos destacados.",
  "err.invalidDeck": "Deck inválido: 1 carta de cada tier e no máximo 1 por categoria (2 Energias).",
  "err.notOwned": "Você ainda não tem esse item.",
  "err.alreadyOwned": "Você já tem esse item.",
  "err.paymentProvider": "O Mercado Pago não respondeu. Tente de novo em instantes.",

  // título
  "title.set": "Set 1 · Kanto",
  "title.start": "Começar",
  "title.tap": "Toque para começar",
  "title.credits": "Créditos",

  // menu
  "menu.title": "Menu",
  "menu.accountLevel": "Nível de conta {n}",
  "menu.logout": "Sair",
  "menu.welcome": "Conta criada! Bem-vindo, {name}.",
  "menu.confirmEmail": "Confirme seu e-mail ({email}) para conseguir recuperar a senha se esquecer.",
  "menu.resend": "Reenviar link",
  "menu.play": "Jogar",
  "menu.play.sub": "Partida normal · até 8 jogadores",
  "menu.ranked": "Ranqueada",
  "menu.ranked.sub": "Season 1 · Kanto",
  "menu.ranked.locked": "Confirme o e-mail para liberar",
  "menu.deck": "Deck de cartas",
  "menu.deck.sub": "Ouro · Prata · Cobre",
  "menu.ranking": "Ranking",
  "menu.ranking.sub": "Top da season e histórico",
  "menu.collection": "Coleção",
  "menu.collection.sub": "Shinies",
  "menu.shop": "Loja VIP",
  "menu.shop.sub": "Cristais e tabuleiros",
  "menu.friends": "Jogar com amigos",
  "menu.friends.text": "Combine um código e todos entram na mesma sala. Quem entrar primeiro decide quando começar.",
  "menu.friends.placeholder": "Código da sala (ex.: PALLET)",
  "menu.friends.join": "Entrar",
  "menu.linkSent": "Link enviado! Confira sua caixa de entrada (e o spam).",
  "menu.err.verify": "Confirme seu e-mail para jogar ranqueada.",
  "menu.err.connect": "Não foi possível conectar ao servidor de jogo.",
  "menu.err.code": "Use um código com pelo menos 3 letras ou números.",
  "menu.rejoin": "Você tem uma partida em andamento.",
  "menu.rejoin.button": "Voltar para a partida",
  "menu.rejoin.expired": "A partida já terminou ou o tempo para voltar expirou.",

  // fila
  "lobby.title": "Procurando partida",
  "lobby.players": "Jogadores",
  "lobby.playersCount": "Jogadores ({n}/{max})",
  "lobby.start": "Começar agora",
  "lobby.leave": "Sair da fila",
  "lobby.you": "você",
  "lobby.cancelled": "Partida cancelada: poucos jogadores. Volte ao menu e tente de novo.",
  "lobby.hint.solo": "Você pode começar sozinho: as rodadas de PvP serão contra treinadores do jogo. Ou espere mais gente entrar.",
  "lobby.hint.host": "Você é o dono da sala: comece quando quiser.",
  "lobby.hint.wait": "Aguardando o dono da sala começar (ou a sala lotar).",

  // partida
  "match.level": "Nv. {n}",
  "match.badges": "Insígnias",
  "match.quit": "Sair da partida",
  "match.trainers": "Treinadores",
  "match.traits": "Sinergias",
  "match.traits.empty": "Coloque unidades no tabuleiro para ativar sinergias.",
  "match.lockShop": "Travar loja",
  "match.free": "grátis ({n})",
  "match.round.pve": "Selvagens",
  "match.round.pvp": "Batalha",
  "match.round.safari": "Safari Zone",
  "match.round.gym": "Líder de Ginásio",
  "match.err.not-enough-gold": "Ouro insuficiente",
  "match.err.bench-full": "Banco cheio",
  "match.err.board-full": "Tabuleiro cheio para o seu nível. Suba de nível com XP",
  "match.err.max-level": "Nível máximo",
  "match.err.items-full": "A unidade já tem 3 itens",
  "match.err.not-planning": "Espere a fase de planejamento",
  "match.err.rate-limited": "Calma! Muitas ações por segundo",
  "match.range": "alcance {n}",
  "match.mana": "mana",
  "match.sell": "Vender +{n}",
  "match.equip": "Equipar",
  "match.equipHint": "Agora toque na unidade que vai receber o componente",
  "match.badge.choose": "Escolha o bônus da insígnia.",
  "match.branch.choose": "Escolha a evolução",
  "match.backpack": "Mochila: escolha um componente",
  "match.safari.text": "Escolha um Pokémon (com componente). Quem tem menos vida escolhe primeiro.",
  "match.safari.picked": "Escolha registrada. Você pode trocar até o fim do tempo.",
  "match.safari.toast": "Safari Zone: escolha um Pokémon!",
  "match.gym.toast": "{leader} quer batalhar! Vença para escolher o bônus da {badge}.",
  "match.quit.title": "Sair da partida?",
  "match.quit.text": "Seu tabuleiro continua na partida, parado, até ela acabar. Você pode voltar pelo menu.",
  "match.quit.yes": "Sair",
  "match.quit.no": "Continuar jogando",
  "match.end.league": "Você venceu a Liga de Kanto!",
  "match.end.journey": "Fim da jornada",
  "match.end.top4": "Top 4!",
  "match.end.over": "Fim de jogo",
  "match.end.points": "{n} pontos",
  "match.end.xp": "+{n} XP de conta",
  "match.end.levelUp": "Subiu para o nível {n}!",
  "match.end.newCard": "Nova carta:",
  "match.end.shiny": "Novo shiny desbloqueado! Veja na Coleção.",
  "match.end.menu": "Voltar ao menu",
  "match.reconnecting": "Conexão perdida. Reconectando…",
  "match.reconnectFailed": "Não foi possível voltar à partida.",
  "match.vs.wild": "Selvagens / Líder",
  "match.vs.npc": "Treinador do jogo",
  "match.combat": "Combate",
  "match.combatVs": "Combate · vs {name}",

  // tooltips e atributos
  "tip.component": "Componente",
  "tip.item": "Item",
  "tip.combine": "Junte 2 componentes na mesma unidade para formar um item:",
  "tip.onBoard": "{n} no tabuleiro",
  "stat.adPct": "+{v}% de dano de ataque",
  "stat.ap": "+{v} de poder de habilidade",
  "stat.asPct": "+{v}% de velocidade de ataque",
  "stat.critPct": "+{v}% de chance de crítico",
  "stat.armor": "+{v} de armadura",
  "stat.mr": "+{v} de resistência mágica",
  "stat.hp": "+{v} de HP",
  "stat.startMana": "+{v} de mana inicial",

  // cartas
  "tier.gold": "Ouro",
  "tier.silver": "Prata",
  "tier.copper": "Cobre",
  "deck.title": "Deck de cartas",
  "deck.yours": "Seu deck · Kanto",
  "deck.empty": "Vazio",
  "deck.emptyHint": "Escolha uma carta deste tier na coleção abaixo.",
  "deck.save": "Salvar deck",
  "deck.rules": "1 carta de cada tier · máximo de {energy} Energias e 1 de cada outra categoria",
  "deck.allUnlocked": " · todas liberadas (nível {n}+)",
  "deck.unlockAt": " · todas liberam no nível {n}",
  "deck.collection": "Coleção",
  "deck.all": "Todas",
  "deck.locked": "Ganhe subindo de nível",
  "deck.saved": "Deck salvo! Vale a partir da próxima partida.",
  "deck.needAll": "Escolha uma carta para cada tier (Ouro, Prata e Cobre).",

  // ranking
  "ranking.title": "Ranking",
  "ranking.noSeason": "Nenhuma season ativa no momento.",
  "ranking.endsIn": "termina em {n} dia(s)",
  "ranking.you": "Você:",
  "ranking.unranked": "Sem partidas ranqueadas",
  "ranking.placement": "{n} partida(s) de colocação (pontos em dobro)",
  "ranking.trainer": "Treinador",
  "ranking.games": "Partidas",
  "ranking.elo": "Elo",
  "ranking.gamesWins": "{n} ({w} vitórias)",
  "ranking.empty": "Ninguém jogou ranqueada ainda. Seja o primeiro!",
  "ranking.history": "Suas últimas partidas",
  "ranking.placeOf": "{p}º de {n}",
  "ranking.mode.ranked": "Ranqueada",
  "ranking.mode.custom": "Com amigos",
  "ranking.mode.normal": "Normal",
  "ranking.noMatches": "Nenhuma partida ainda.",
  "ranking.pts": "{n} pts",
  "rank.pokeball": "Poké Ball",
  "rank.greatball": "Great Ball",
  "rank.ultraball": "Ultra Ball",
  "rank.masterball": "Master Ball",

  // coleção
  "collection.title": "Coleção",
  "collection.text": "Shinies são só visuais: aparecem para todos na partida. Compre com Pokédollar ou ganhe subindo de nível de conta (a cada 5 níveis) e pelo seu melhor tier na season.",
  "collection.showOwned": "Mostrar só os seus",
  "collection.showingOwned": "Mostrando só os seus",
  "collection.count": "{n} de {total}",
  "collection.tapToEquip": "Toque para equipar",
  "rarity.common": "Comum",
  "rarity.rare": "Raro",
  "rarity.epic": "Épico",
  "rarity.legendary": "Lendário",

  // loja VIP
  "shop.title": "Loja VIP",
  "shop.crystals": "cristais",
  "shop.tab.boards": "Tabuleiros",
  "shop.tab.crystals": "Cristais",
  "shop.tab.history": "Histórico",
  "shop.boards.explain": "Tabuleiros mudam a arena da partida. Numa batalha entre dois jogadores, os dois veem o tabuleiro de quem tem mais vida; na próxima vez que se enfrentarem, o do outro. Só visual: não dá vantagem.",
  "shop.default": "Padrão",
  "shop.default.desc": "O estádio azul e vermelho clássico, grátis para todos.",
  "shop.equip": "Equipar",
  "shop.equipped": "Equipado",
  "shop.animated": "Animado",
  "shop.preview": "Ver prévia",
  "shop.confirmBuy": "Confirmar? {price}",
  "shop.bought": "{name} comprado e equipado!",
  "shop.notEnough": "Cristais insuficientes. Veja os pacotes de cristais.",
  "shop.crystals.explain": "Cristais são doações que ajudam a manter o servidor no ar. Eles compram apenas itens visuais e nunca dão vantagem no jogo.",
  "shop.bonus": "de bônus",
  "shop.donate": "Doar {price}",
  "shop.mp.note": "Pagamento processado pelo Mercado Pago (Pix, cartão ou boleto). Os cristais entram assim que o pagamento é aprovado.",
  "shop.devMode": "Modo de teste: nenhum valor é cobrado (servidor sem Mercado Pago configurado).",
  "shop.paymentsOff": "Doações indisponíveis no momento.",
  "shop.donation.ok": "Obrigado pela doação! {n} cristais adicionados.",
  "shop.donation.waiting": "Aguardando a confirmação do pagamento…",
  "shop.donation.failed": "O pagamento não foi concluído. Nenhum valor foi cobrado.",
  "shop.history.empty": "Nenhuma doação ainda.",
  "shop.history.date": "Data",
  "shop.history.value": "Valor",
  "shop.history.status": "Situação",
  "shop.status.pending": "Pendente",
  "shop.status.in_process": "Em análise",
  "shop.status.approved": "Aprovado",
  "shop.status.rejected": "Recusado",
  "shop.status.cancelled": "Cancelado",
  "shop.status.refunded": "Estornado",
  "shop.status.charged_back": "Contestado",
  "shop.devCheckout.title": "Checkout de teste",
  "shop.devCheckout.text": "Simule o resultado do pagamento desta doação.",
  "shop.devCheckout.approve": "Aprovar pagamento",
  "shop.devCheckout.reject": "Recusar",

  // créditos
  "credits.title": "Créditos",
  "credits.sprites": "Sprites dos Pokémon",
  "credits.spritesText": "Animações de {source}, licença {license}. Arte de:",
  "credits.items": "Itens, dados e fontes",
  "credits.itemsText": "Ícones de itens, nomes e dados das espécies: {source} / PokéAPI.",
  "credits.fonts": "Fontes: Jersey 10 e DotGothic16 (SIL Open Font License).",
  "credits.trademark": "Pokémon e todos os nomes relacionados são marcas de Nintendo, Game Freak e Creatures. Projeto de fã, sem afiliação.",
  "credits.error": "Não foi possível carregar os créditos.",
  // efeitos de combate
  "fx.effective": "eficaz",
  "fx.shield": "escudo",
  "fx.stun": "atordoado",
  "fx.sleep": "zzz",
  "fx.freeze": "congelado",
  "fx.confuse": "confuso",
  "fx.burn": "queimando",
  "fx.poison": "envenenado",
  "fx.intangible": "intangível",
  // foto de perfil
  "avatar.change": "Trocar foto de perfil",
  "avatar.title": "Escolha sua foto de perfil",
  "avatar.search": "Buscar Pokémon",
  "avatar.saved": "Foto de perfil atualizada!",
  "market.title": "Mercado Pokémon",
  "market.tab.special": "Especiais",
  "market.tab.item": "Itens completos",
  "market.tab.component": "Componentes",
  "market.explain": "Itens comprados entram no seu item pool: nas recompensas da partida, itens prontos do pool podem cair já montados (6% por item, até 30%) e componentes do pool caem com o dobro de chance.",
  "market.inPool": "{n} no seu pool.",
  "market.owned": "No seu pool",
  "market.bought": "{name} entrou no seu item pool!",
  "match.end.pokedollars": "+{n} Pokédollar",
  "menu.market": "Mercado",
  "menu.market.sub": "Itens com Pokédollar",
  "pdx.confirm": "Comprar? {price}",
  "pdx.explain": "Pokédollar: ganhe de 0 a 100 por partida (1º lugar = 100). Compra cartas, shinies e itens.",
  "pdx.notEnough": "Pokédollar insuficiente. Jogue partidas para ganhar mais.",
  "tip.special": "Especial",
  "tip.specialHint": "Só comprando no Mercado: cai pronto na partida e ocupa 2 espaços.",
  "changelog.title": "Novidades",
  "changelog.version": "Versão {v}",
  "changelog.new": "Novo",
  "changelog.link": "Novidades da versão {v}",
  "tip.unit.cost": "Custo {n}",
  "tip.unit.evolves": "Evolução:",
  "tip.unit.branch": "à escolha",
  "tip.unit.owned": "Você já tem {n} cópia(s): 3 cópias viram ★2.",
  "social.title": "Amigos e chat",
  "social.global": "Global",
  "social.friendsTab": "Amigos",
  "social.say": "Digite uma mensagem…",
  "social.send": "Enviar",
  "social.empty": "Nenhuma mensagem ainda.",
  "social.addPlaceholder": "Usuário do amigo",
  "social.add": "Adicionar",
  "social.incoming": "Pedidos de amizade",
  "social.outgoing": "Pedidos enviados",
  "social.friends": "Amigos ({n})",
  "social.noFriends": "Adicione amigos pelo nome de usuário.",
  "social.remove": "Remover",
  "social.requestSent": "Pedido enviado!",
  "social.nowFriends": "Agora vocês são amigos!",
  "social.roomChat": "Chat da sala",
  "social.err.notFound": "Usuário não encontrado.",
  "social.err.self": "Você não pode se adicionar.",
  "social.err.already": "Vocês já são amigos.",
  "social.err.notFriends": "Só dá para conversar com amigos.",
  "menu.creche": "Criadouro",
  "menu.creche.sub": "Crie e libere Pokémon",
  "creche.title": "Criadouro",
  "creche.explain": "Crie um Pokémon de uma linha bloqueada até o nível {max} para liberar essa linha na sua loja da partida. Cuide dele e jogue partidas: ele ganha XP com você.",
  "creche.level": "Nível {n}/{max}",
  "creche.unlocks": "libera a linha de {name}",
  "creche.xp": "XP",
  "creche.belly": "Barriga",
  "creche.happiness": "Felicidade",
  "creche.mood.hungry": "Está com fome! Alimente para ele ganhar XP cheio.",
  "creche.mood.sad": "Está triste… brinque com ele.",
  "creche.mood.joy": "Muito feliz! Ganha XP cheio nas partidas.",
  "creche.mood.ok": "Está bem. Ganha XP cheio nas partidas.",
  "creche.feed": "Alimentar",
  "creche.play": "Brincar",
  "creche.train": "Treinar",
  "creche.tips": "Cada partida dá 20 XP (10 se estiver com fome ou triste). Brincar: a cada 30 min. Treinar: a cada 2 h, dá 30 XP.",
  "creche.release": "Soltar este Pokémon",
  "creche.releaseConfirm": "Toque de novo para soltar (perde o progresso)",
  "creche.choose": "Escolha um Pokémon para criar. Ao chegar ao nível máximo, a linha dele passa a aparecer na sua loja da partida.",
  "creche.allDone": "Você já liberou todas as linhas! Sua Pokédex está completa.",
  "creche.dex": "Pokédex de Kanto: {n}/{total} liberados",
  "creche.adopted": "{name} chegou ao Criadouro!",
  "creche.unlocked": "{name} foi liberado na sua loja!",
  "creche.gotXp": "+{n} XP",
  "creche.err.not-hungry": "Ele não está com fome agora.",
  "creche.err.too-hungry": "Está com fome demais. Alimente primeiro.",
  "creche.err.too-sad": "Está triste demais para treinar. Brinque com ele.",
  "creche.err.cooldown": "Ele precisa descansar um pouco.",
  "menu.missions": "Missões",
  "menu.missions.sub": "Prêmios diários em ₽",
  "missions.title": "Missões diárias",
  "missions.intro": "Complete as missões jogando partidas e resgate o prêmio. Novas missões em",
  "missions.resetsIn": "{t}",
  "missions.streak": "{n} dia(s) seguido(s) jogando",
  "missions.best": "Recorde: {n}",
  "missions.completedTotal": "{n} missões concluídas",
  "missions.seeRanking": "Ver ranking",
  "missions.claimed": "Resgatado",
  "missions.got": "+₽ {n}!",
  "missions.hint": "O progresso conta ao fim de cada partida.",
  "missions.doneInMatch": "{n} missão(ões) concluída(s)! Resgate o prêmio.",
  "missions.k.synergy": "Consiga {n} de {trait} numa partida",
  "missions.k.play": "Jogue {n} partidas",
  "missions.k.win": "Vença {n} partida(s)",
  "missions.k.tophalf": "Termine na metade de cima {n} vezes",
  "missions.k.ranked-play": "Jogue {n} ranqueada(s)",
  "missions.k.ranked-win": "Vença {n} ranqueada(s)",
  "missions.k.pvp-wins": "Vença {n} rodadas contra jogadores",
  "missions.k.star3": "Consiga um Pokémon 3 estrelas",
  "missions.k.items": "Tenha {n} itens completos no tabuleiro",
  "missions.k.level": "Chegue ao nível {n} numa partida",
  "ranking.tab.ranked": "Ranqueada",
  "ranking.tab.level": "Nível",
  "ranking.tab.missions": "Missões",
  "ranking.tab.streak": "Dias seguidos",
  "ranking.about.level": "Nível da conta: sobe com XP de cada partida.",
  "ranking.about.missions": "Total de missões diárias concluídas e resgatadas.",
  "ranking.about.streak": "Dias seguidos entrando no jogo. Pulou um dia, a sequência recomeça.",
  "ranking.col.level": "Nível",
  "ranking.col.missions": "Missões",
  "ranking.col.streak": "Dias",
  "ranking.levelValue": "Nv. {n}",
  "ranking.missionsValue": "{n}",
  "ranking.streakValue": "{n} dias",
  "ranking.bestStreak": "recorde {n}",
  "match.migrating": "Atualizando o servidor… voltando para a partida.",
  "queue.searching": "Procurando partida…",
  "queue.searchingRanked": "Procurando ranqueada…",
  "queue.starting": "Entrando na fila",
  "queue.progress": "{time} · {n} na fila · faixa de ±{range}",
  "queue.cancel": "Cancelar",
  "match.vs.ghost": "{name} (partida gravada)",
  "common.sound": "Som e vibração",
  "menu.achievements": "Conquistas",
  "menu.achievements.sub": "Títulos e molduras",
  "ach.title": "Conquistas",
  "ach.unlocked": "desbloqueadas",
  "ach.titleLabel": "Título",
  "ach.frameLabel": "Moldura",
  "ach.none": "Nenhum",
  "ach.secretName": "Conquista secreta",
  "ach.secretDesc": "Continue jogando para descobrir.",
  "ach.frameReward": "moldura",
  "ach.saved": "Perfil atualizado.",
  "ach.cat.jornada": "Jornada",
  "ach.cat.colecao": "Coleção",
  "ach.cat.habilidade": "Habilidade",
  "ach.cat.secreta": "Secretas",
  "ach.frame.ouro": "Ouro",
  "ach.frame.prata": "Prata",
  "ach.frame.master": "Master Ball",
  "ach.frame.pokedex": "Pokédex",
  "ach.frame.shiny": "Brilhante",
  "ach.toast": "Conquista: {name}!",
  "ach.inMatch": "{n} conquista(s) nova(s)!",
  "report.button": "Denunciar ou bloquear",
  "report.title": "Denunciar {name}",
  "report.why": "O que aconteceu?",
  "report.reason.nickname": "Apelido ofensivo",
  "report.reason.chat": "Chat ofensivo ou spam",
  "report.reason.afk": "Abandonou / parado",
  "report.reason.cheating": "Trapaça",
  "report.reason.other": "Outro",
  "report.details": "Detalhes (opcional)",
  "report.alsoBlock": "Também bloquear esta pessoa",
  "report.note": "Guardamos as mensagens recentes como prova. Denúncias falsas podem gerar punição.",
  "report.send": "Denunciar",
  "report.blockOnly": "Só bloquear",
  "report.unblock": "Desbloquear",
  "report.thanks": "Obrigado! A moderação vai analisar.",
  "social.muted": "Seu chat está silenciado até {when}.",
  "mod.title": "Moderação",
  "mod.open": "Abertas",
  "mod.closed": "Resolvidas",
  "mod.by": "por {name} · {when}",
  "mod.counts": "{open} denúncia(s) abertas · {people} pessoa(s) diferentes",
  "mod.mutedUntil": "silenciado até {when}",
  "mod.bannedUntil": "suspenso até {when}",
  "mod.nickAtTime": "Apelido na hora: {name}",
  "mod.evidence": "Provas ({n} mensagens)",
  "mod.room": "sala",
  "mod.noEvidence": "Sem mensagens guardadas.",
  "mod.dismiss": "Arquivar",
  "mod.mute24": "Silenciar 24 h",
  "mod.rename": "Renomear",
  "mod.ban3d": "Suspender 3 dias",
  "mod.ban1y": "Banir",
  "mod.confirm": "Confirmar?",
  "mod.result": "{action} · {when}",
  "mod.empty": "Nenhuma denúncia aqui.",
  "mod.done": "Feito.",
  "menu.moderation": "Moderação",
  "share.tagline": "Autochess de Pokémon no navegador",
  "share.ofN": "de {n}",
  "share.solo": "solo",
  "share.trainer": "Treinador",
  "share.team": "Meu time",
  "share.level": "Nível {n}",
  "share.round": "Rodada {r}",
  "share.wins": "{n} vitórias",
  "share.cta": "Jogue grátis — sem baixar nada",
  "share.text": "Fiquei em {place}º de {n} no PokéChess! Jogue grátis: {url}",
  "share.button": "Compartilhar resultado",
  "share.downloaded": "Imagem salva!",
  "ach.primeira-partida.name": "Primeiros passos",
  "ach.primeira-partida.desc": "Jogue sua primeira partida.",
  "ach.partidas-10.name": "Treinador iniciante",
  "ach.partidas-10.desc": "Jogue {n} partidas.",
  "ach.partidas-100.name": "Veterano",
  "ach.partidas-100.desc": "Jogue {n} partidas.",
  "ach.partidas-1000.name": "Lenda de Kanto",
  "ach.partidas-1000.desc": "Jogue {n} partidas.",
  "ach.primeira-vitoria.name": "Primeira vitória",
  "ach.primeira-vitoria.desc": "Vença uma partida com outros jogadores.",
  "ach.vitorias-10.name": "Campeão",
  "ach.vitorias-10.desc": "Vença {n} partidas.",
  "ach.vitorias-50.name": "Imbatível",
  "ach.vitorias-50.desc": "Vença {n} partidas.",
  "ach.top4-25.name": "Sempre no pódio",
  "ach.top4-25.desc": "Termine entre os 4 primeiros {n} vezes.",
  "ach.ranqueada-vitorias-10.name": "Ás da Liga",
  "ach.ranqueada-vitorias-10.desc": "Vença {n} ranqueadas.",
  "ach.master-ball.name": "Mestre Pokémon",
  "ach.master-ball.desc": "Chegue à Master Ball numa season.",
  "ach.dias-7.name": "Uma semana firme",
  "ach.dias-7.desc": "Jogue {n} dias seguidos.",
  "ach.dias-30.name": "Fiel",
  "ach.dias-30.desc": "Jogue {n} dias seguidos.",
  "ach.missoes-50.name": "Cumpridor de missões",
  "ach.missoes-50.desc": "Conclua {n} missões diárias.",
  "ach.nivel-20.name": "Treinador experiente",
  "ach.nivel-20.desc": "Chegue ao nível {n} de conta.",
  "ach.criadouro-1.name": "Primeiro do Criadouro",
  "ach.criadouro-1.desc": "Libere uma linha no Criadouro.",
  "ach.pokedex-completa.name": "Professor",
  "ach.pokedex-completa.desc": "Libere todas as {n} linhas do Criadouro.",
  "ach.shinies-5.name": "Brilho raro",
  "ach.shinies-5.desc": "Tenha {n} shinies.",
  "ach.shinies-25.name": "Caçador de Shinies",
  "ach.shinies-25.desc": "Tenha {n} shinies.",
  "ach.cartas-10.name": "Colecionador",
  "ach.cartas-10.desc": "Tenha {n} cartas.",
  "ach.agua-7.name": "Mestre das Águas",
  "ach.agua-7.desc": "Consiga 7 de Água numa partida.",
  "ach.voador-7.name": "Dono dos céus",
  "ach.voador-7.desc": "Consiga 7 de Voador numa partida.",
  "ach.brigao-6.name": "Briga de rua",
  "ach.brigao-6.desc": "Consiga 6 Brigões numa partida.",
  "ach.muralha-6.name": "Inabalável",
  "ach.muralha-6.desc": "Consiga 6 Muralhas numa partida.",
  "ach.tres-estrelas-3.name": "Estrelado",
  "ach.tres-estrelas-3.desc": "Tenha 3 Pokémon ★3 ao mesmo tempo.",
  "ach.vitoria-por-um-fio.name": "Por um fio",
  "ach.vitoria-por-um-fio.desc": "Vença com 5 de vida ou menos.",
  "ach.nivel-9.name": "Nível máximo",
  "ach.nivel-9.desc": "Chegue ao nível 9 numa partida.",
  "ach.itens-6.name": "Arsenal",
  "ach.itens-6.desc": "Tenha 6 itens completos no tabuleiro.",
  "ach.giovanni.name": "Derrotou Giovanni",
  "ach.giovanni.desc": "Vença a partida solo até a 8-7.",
  "ach.dragonite-3.name": "Dragão lendário",
  "ach.dragonite-3.desc": "Faça um Dragonite ★3.",
  "ach.magikarp-3.name": "Splash!",
  "ach.magikarp-3.desc": "Faça um Magikarp ★3.",
  "ach.so-custo-1.name": "Humilde",
  "ach.so-custo-1.desc": "Vença usando só Pokémon de custo 1.",
  "ach.sem-vitoria-top4.name": "Sobrevivente",
  "ach.sem-vitoria-top4.desc": "Fique no top 4 sem vencer nenhuma luta.",
  "ach.mewtwo.name": "Clone poderoso",
  "ach.mewtwo.desc": "Coloque um Mewtwo em campo.",
  "tut.coach": "Professor Carvalho",
  "tut.next": "Próximo passo",
  "tut.shop": "Esta é a loja. Toque num Pokémon para comprar: o número é o preço em ouro.",
  "tut.place": "Ele foi para o banco. Arraste para o tabuleiro: só quem está no tabuleiro luta.",
  "tut.fight": "Pronto? Toque em Lutar! A batalha é automática.",
  "tut.watch": "Seus Pokémon lutam sozinhos. Vencendo, você ganha ouro e itens.",
  "tut.combine": "3 Pokémon iguais viram ★2, bem mais fortes. Os que você já tem brilham na loja.",
  "tut.traits": "Pokémon do mesmo tipo ativam sinergias. Veja em Sinergias quais estão ativas.",
  "tut.items": "Você ganhou um componente! Toque nele e depois num Pokémon para equipar. Dois componentes viram um item.",
  "tut.xp": "Compre XP para subir de nível: cada nível deixa colocar mais um Pokémon no tabuleiro.",
  "tut.interest": "Dica de mestre: guardar ouro rende juros, +1 a cada 10 (até +5) por rodada.",
  "tut.end": "Agora é com você! Vença esta luta para terminar o tutorial.",
  "tut.fightBtn": "Lutar!",
  "tut.offerTitle": "Primeira vez por aqui?",
  "tut.offer": "Aprenda a jogar em 3 minutos com uma partida guiada e ganhe ₽ {n}.",
  "tut.start": "Começar o tutorial",
  "tut.skip": "Já sei jogar",
  "tut.done": "Tutorial concluído!",
  "menu.tutorial": "Tutorial",
  "menu.tutorial.sub": "Aprenda em 3 minutos",
  "lobby.fillBots": "Completar com bots",
  "lobby.fillBotsHint": "As vagas livres viram treinadores do jogo.",
};
export type Messages = { [K in keyof typeof pt]: string };
export default pt as Messages;
